<template>
    <svg
        v-if="!hidden"
        v-b-tooltip.hover 
        :class="{'favorited': favorited}"
        @click="favorite"
        title="Add to favorites"
        width="28" height="28" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12.3564" r="12" fill="#F4F4F4" />
            <path
                d="M12.0003 18.8391L11.0872 17.9275C7.69591 14.9323 5.47852 12.9138 5.47852 10.4396C5.47852 8.42109 7.04373 6.8584 9.06547 6.8584C10.1742 6.8584 11.2829 7.3793 12.0003 8.22576C12.7177 7.3793 13.8263 6.8584 14.935 6.8584C16.9568 6.8584 18.522 8.42109 18.522 10.4396C18.522 12.9138 16.3046 14.9323 12.9133 17.9275L12.0003 18.8391Z"
                fill="#B8CDD7" />
    </svg>

</template>

<script>
import { db } from '../../firebase'
import FavoriteIcon from '../../assets/img/cardimg/cardicons/favorite.svg'
import { mapState } from 'vuex'
import { message } from 'ant-design-vue'

export default {
    name: 'Favorite',
    components: {
        FavoriteIcon,
    },
    props: {
        cardData: Object,
        favoriteLocation: String
    },
    data() {
        return {
            favorited: false,
        }
    },
    computed: {
        ...mapState([
            'user',
        ]),
        hidden: function () {
            if (this.user && this.user.uid && this.user.uid === this.cardData.author_id) {
                return true
            }

            return false
        },
    },
    mounted: function() {
        this.favorited = this.user && this.cardData.favorites && this.cardData.favorites[this.user.uid]
    },
    methods: {
        favorite: function() {
            if (!this.user) {
                return this.$store.commit('TOGGLE_MODAL', ['sign-up', {
                    openedFrom: 'Favorite Icon'
                }])
            }

            this.favorited = !this.favorited
            this.$parent.$emit('favorite', [this.cardData.id, this.favorited])

            if (!this.favorited) {
                message.info('The campaign is removed from favorites')
            }

            const campaignRef = db.collection('campaigns').doc(this.cardData.id)
            db.runTransaction(transaction => {
                return transaction.get(campaignRef).then(
                    campaign => {
                        const data = campaign.data()
                        
                        if (!data.favorites) {
                            data.favorites = {}
                        }

                        data.favorites[this.user.uid] = this.favorited
                        transaction.update(campaignRef, { favorites: data.favorites })

                        this.$sendMixpanelEvent('Favorite Clicked', {
                            'Heart Icon Location': this.favoriteLocation,
                            'Favorited Campaign': data.title,
                            'Is Favorited': this.favorited
                        });

                        this.$ga.event('Campaign', 'Favorite Click',`
                            Location: ${this.favoriteLocation},
                            Campaign: ${data.title},
                            Favorited: ${this.favorited}
                        `);

                        
                    }
                )
            }).catch(console.error)
        }
    }
}
</script>

<style scoped lang="scss">
    svg {
        cursor: pointer;

        path {
            transition: all 0.3s ease;

        }

        &:hover {
            path {
                fill: #ffffff;
            }
            circle {
                fill: #8DA0A9;
            }
        }

        &.favorited {
            path {
                fill: #FA5C7C;
            }
        }
    }
</style>